import React from 'react';

const FormSVG = () => (
  <svg
    enableBackground="new 0 0 64 64"
    id="Layer_1"
    version="1.1"
    viewBox="0 0 64 64"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg">
    <g>
      <path d="M9.8,29.3H50V10.7H9.8V29.3z M11.3,12.2h37.3v15.7H11.3V12.2z" />
      <path d="M30.7,31.3H9.8v11.1h20.9V31.3z M29.2,40.9H11.3v-8.2h17.9V40.9z" />
      <path d="M54.6,3.7V0v0H5.2l0,60.8h3.7V64h50V3.7H54.6z M6.6,1.5h46.5v4.3H6.6V1.5z M6.6,59.4V7.2h46.5v52.2H6.6z M57.4,62.5H10.3   v-1.7h44.3V5.2h2.8V62.5z" />
      <rect height="1.5" width="17.7" x="14.6" y="15.5" />
      <rect height="1.5" width="1.5" x="14.6" y="23.5" />
      <rect height="1.5" width="1.5" x="18.2" y="23.5" />
      <rect height="1.5" width="1.5" x="25.5" y="23.5" />
      <rect height="1.5" width="1.5" x="29.1" y="23.5" />
      <rect height="1.5" width="1.5" x="21.9" y="23.5" />
      <rect height="1.5" width="1.5" x="16.8" y="2.9" />
      <rect height="1.5" width="1.5" x="13.2" y="2.9" />
      <rect height="1.5" width="1.5" x="9.6" y="2.9" />
      <rect height="1.5" width="1.3" x="20.4" y="2.9" />
      <rect height="1.5" width="14.2" x="14.6" y="19.5" />
      <rect height="1.5" width="40.2" x="9.8" y="47.5" />
      <rect height="1.5" width="16.7" x="33.3" y="33.1" />
      <rect height="1.5" width="16.7" x="33.3" y="37" />
      <rect height="1.5" width="11.4" x="33.3" y="40.9" />
      <rect height="1.5" width="40.2" x="9.8" y="52.4" />
    </g>
  </svg>
);

export default FormSVG;
